import { FC } from 'react'

import { RequestByIdApiType } from '@/api/models/requests'
import UserIcon from '@/assets/svg/UserIcon.svg'

type Props = {
  persons: RequestByIdApiType['persons']
  isForGuests: boolean
}

const ContentBlockPersons: FC<Props> = ({ persons, isForGuests }) => (
  <>
    {persons && persons.length > 0 && (
      <div>
        <p className="mb-4 font-bold text-grey-90 text-16">
          {isForGuests ? 'Гости' : 'ФИО'}
        </p>
        <div className="flex flex-col gap-4">
          {persons.map((person, index) => (
            <div
              key={person + index}
              className="flex items-center gap-8 truncate font-pro text-16"
            >
              <UserIcon /> {person}
            </div>
          ))}
        </div>
      </div>
    )}
  </>
)

export default ContentBlockPersons
